import { useEffect, useState } from "react";
import authContext from "./auth-context";
import { IAuthContext } from "../../types/auth";
import useHttp from "../../hooks/use-http";
import Cookie from "js-cookie";

const authReducer = (state: any, action: string) => {};

const AuthProvider = (props: any) => {
  const {
    isLoading,
    isError,
    message,
    sendRequest: loginValidation,
  } = useHttp();

  const [emailState, setEmailState] = useState("");
  const [isLoadingState, setIsLoadingState] = useState(true);
  const [idState, setIdState] = useState("");
  const [nameState, setNameState] = useState("");
  const [firstNameState, setFirstNameState] = useState("");
  const [lastNameState, setLastNameState] = useState("");
  const [companyState, setCompanyState] = useState("");
  const [locationState, setLocationState] = useState("");
  const [isLoggedInState, setIsLoggedInState] = useState(false);
  const [isVarifiedState, setIsVarifiedState] = useState(false);
  const [accountIDState, setAccountIDState] = useState("");
  const [referenceIDState, setReferenceIDState] = useState("");


  const loginResponse = (res: any) => {
    console.log('loginResponse',res);
    setIsLoadingState(false)
    if (res.error === false) {
      setIsLoggedInState(true);
      setEmailState(res.email);
      setNameState(res.name);
      setFirstNameState(res.firstName);
      setLastNameState(res.lastName);
      setCompanyState(res.company)
      setLocationState(res.location)
      setIsVarifiedState(res.isVarified);      
    }
  };

  

  const loginHandler = (data: any) => {
    setIsLoadingState(true);
    loginValidation(
      {
        URL: "/api/user/login",
        method: "POST",
        header: {
          "Content-Type": "application/json",
        },
        body: {
          email: data.email,
          password: data.password,
        },
      },
      loginResponse
    );
  };

  const logoutHandler = () => {
    Cookie.remove("accessToken");
    Cookie.remove("refreshToken");
    setIsLoggedInState(false);
    setNameState("");
    setIsVarifiedState(false);
    setEmailState("");
  };


  const setInfo = (data: any) =>{
    setIsLoadingState(false)
    if (data.authUserInfo) {
      setIsLoggedInState(true);
      setEmailState(data.authUserInfo.email);
      setNameState(data.authUserInfo.name);
      setFirstNameState(data.authUserInfo.firstName);
      setLastNameState(data.authUserInfo.lastName);
      setIsVarifiedState(data.authUserInfo.isVerified);
      setAccountIDState(data.authUserInfo.accountID);
      setReferenceIDState(data.authUserInfo.referenceID);
      
    }
  }

  const authContextValue: IAuthContext = {
    isAuthError: isError,
    authMessage: message,
    authLoading: isLoadingState,
    isLoggedIn: isLoggedInState,
    isLoading: isLoading,
    userInfo: {
      id: idState,
      name: nameState,
      firstName: firstNameState,
      lastName: lastNameState,
      company: companyState,
      location: locationState,
      email: emailState,
      isVarified: isVarifiedState,
      accountID: accountIDState,
      referenceID: referenceIDState

    },
    login: loginHandler,
    logout: logoutHandler,
    setUserInfo: setInfo,
  };


  return (
    <authContext.Provider value={authContextValue}>
      {props.children}
    </authContext.Provider>
  );
};

export default AuthProvider;
